/**
 * Lazy-load Google Maps JS API with the Places library exactly once.
 * Returns a promise that resolves to window.google.
 *
 * If REACT_APP_GOOGLE_MAPS_API_KEY is unset, the promise rejects so callers
 * can fall back to a plain text input.
 */
let _promise = null;

export function loadGoogleMaps() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("not-browser"));
  }
  if (window.google?.maps?.places) {
    return Promise.resolve(window.google);
  }
  if (_promise) return _promise;

  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) {
    return Promise.reject(new Error("no-api-key"));
  }

  _promise = new Promise((resolve, reject) => {
    const cbName = `__gm_cb_${Date.now()}`;
    window[cbName] = () => {
      delete window[cbName];
      resolve(window.google);
    };
    const script = document.createElement("script");
    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}` +
      `&libraries=places&loading=async&callback=${cbName}`;
    script.async = true;
    script.defer = true;
    script.onerror = () => reject(new Error("script-load-failed"));
    document.head.appendChild(script);
  });
  return _promise;
}
